export enum TipoAvaliacao {
  muitoRuim = '0 - Muito ruim',
  ruim = '1 - Ruim',
  podeMelhorar = '2 - Pode melhorar',
  regular = '3 - Regular',
  boa = '4 - Boa',
  otima = '5 - Ótima',
}
